const MAX_AVATAR_SIZE = 5 * 1024 * 1024;
const SUPPORTED_AVATAR_TYPES = ["image/jpeg", "image/png", "image/webp"];
const SUPPORTED_AVATAR_EXTENSIONS = /\.(jpe?g|png|webp)$/i;

const getAvatarFileError = (file) => {
    if (!file) {
        return "请选择头像图片!";
    }

    const hasSupportedType = SUPPORTED_AVATAR_TYPES.includes(file.type) ||
        (!file.type && SUPPORTED_AVATAR_EXTENSIONS.test(file.name || ""));
    if (!hasSupportedType) {
        return "上传头像图片仅支持 JPG、PNG、WebP 格式!";
    }
    if (file.size > MAX_AVATAR_SIZE) {
        return "上传头像图片大小不能超过 5MB!";
    }
    return "";
};

const createAvatarUploadFormData = (file, FormDataConstructor = FormData) => {
    const formData = new FormDataConstructor();
    formData.append("file", file);
    return formData;
};

const createDefaultAvatarSubmission = () => ({ head: "default" });

module.exports = {
    getAvatarFileError,
    createAvatarUploadFormData,
    createDefaultAvatarSubmission,
};
